<template>
    <div class="row mobile">
        <div class="group">
            <div class="label">{{ item.headline || item.service }}</div>
            <div class="value" v-html="item.body || item.professional" />
        </div>
        <div class="media">
            <div v-if="!!item.media.length" class="page-media">
                <UiImage :src="item?.media[0].webp" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    item: {
        type: Object,
        default: () => ({})
    }
});
</script>
